<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2021-05-12 02:38:33
    Description : gaia48 footer
  -->
  <div class="gaia-footer">
    <div class="main">
      <img src="@/assets/images/gaia48/gaia48-logo.png" />
      <span class="item" @click="jumpTo('/desktop/gaia-48/info?index=1')">
        竞赛细则
      </span>
      <span
        class="item"
        @click="jumpTo('http://gaiamount.mikecrm.com/VV6iRuZ')"
      >
        我要报名
      </span>
      <span class="item" @click="jumpTo('/desktop/gaia-48/introduce?index=0')">
        我要集训
      </span>
      <span
        class="item"
        @click="jumpTo('/desktop/gaia-48/party-night?index=3')"
      >
        参加party
      </span>
      <span class="item" @click="jumpTo('/desktop/about')">
        联系我们
      </span>
      <span class="item" @click="jumpTo('https://works.gaiamount.com/')">
        Gaiamount
      </span>
      <div class="scode">
        <div>
          <img
            src="@/assets/images/gaia48/gaia48-wechat.png"
            style="margin-right: 20px"
          />
          <img src="@/assets/images/gaia48/gaia48-sina.jpg" />
        </div>
        <div>
          <img src="@/assets/images/gaia48/wechat-logo.png" />
          <span class="text" style="margin-right: 36px; font-size: 12px">
            扫一扫关注
          </span>
          <img src="@/assets/images/gaia48/sina-logo.png" />
          <span class="text" style="font-size: 12px">扫一扫关注</span>
        </div>
      </div>
      <div style="height: 102px"></div>
      <div class="text">Gaia48 电影节 ] GAIA48 FILM FESTIVAL</div>
      <div class="text">
        <a href="http://www.beian.miit.gov.cn/" style="text-decoration: none">
          深圳市尊正数字视频有限公司 主办 ｜ © Zunzheng Digital Video
          Co.,Ltd | 粤ICP备 06032157 号
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    jumpTo(url) {
      open(url);
    },
  },
};
</script>
<style lang="less" scoped>
.gaia-footer {
  width: 100%;
  min-width: 1300px;
  height: 300px;
  font-size: 16px;
  box-sizing: border-box;
  background: #1a1a1a;
}
.main {
  width: 960px;
  margin: 0 auto;
  padding: 70px 0 0;
  box-sizing: border-box;
}
.item {
  vertical-align: super;
  color: #ffffff;
  margin: 0 0 0 60px;
  cursor: pointer;
}
.text {
  color: #808080;
  line-height: 30px;
  a {
    color: #808080;
  }
}
.scode {
  position: relative;
  width: 220px;
  height: 0px;
  bottom: -30px;
  left: 90%;
}
</style>
